import RunConfigService from './runConfigService';

/**
 *
 * UrlService
 *
 * @namespace UrlService
 */
const UrlService = function() {

    return {
        extractHostURL,
        extractDomain,
		getLocaleUrl,
        isAuthor,
        isMeCommerce,
        isMeCommerceStorefront,
		isWCMDisabled
    };

    function extractHostURL(url) {
        if (isAuthor()) {
            // NOTE: changed this line bacause in case of local hosst with port this function was producing urls like: 
            // http://localhost:4502/4502/apps/hello/services/regions.storefront.json ('double porting')
            let parsedURL = url.split(window.location.host);
            if (parsedURL.length === 2) {
                return window.location.protocol + "//" + window.location.host + parsedURL[1];
            }
        }

        return url;
    }

    function extractDomain(url) {
        // Remove protocol if present, and extract domain from url
        let domain = url.indexOf("://") > -1 ? url.split('/')[2] : url.split('/')[0];

        // Remove port number from domain if present
        domain = domain.split(':')[0];

        return domain;
    }

    function getLocaleUrl() {
        let runConfig = RunConfigService.getRunConfig();
        let fullPath = window.location.pathname;
        let localeString = '/' + runConfig.language + '_' + runConfig.country + '/';
        return fullPath.indexOf(localeString) > -1 ? fullPath.split(localeString)[0] + localeString : fullPath;
    }

    function isAuthor() {
        // This function has a known flaw for AEM instances running locally with an Apache server:
        // In such cases, this function cannot distinguish between Author mode and Preview mode
        return (window.location.port === "4502" ||
            window.location.hostname.indexOf("auth") !== -1 ||
            !isWCMDisabled());
    }

    function isMeCommerce() {
        return window.location.href.indexOf('mecommerce') > -1;
    }

    function isMeCommerceStorefront() {
        // The page is considered part of MeCommerce Storefront
        // if the url does not begin with dev., test., or www.
        let domain = extractDomain(window.location.href);
        return !domain.startsWith('dev.') &&
            !domain.startsWith('test.') &&
            !domain.startsWith('www.') &&
            domain.indexOf('.mynuskin.') >= 0;  // Without this line you can't run in localhost mode or it will think it is storefront
    }

    function isWCMDisabled() {
        return (typeof(CQ) === 'undefined' ||
            typeof(CQ.WCM) === 'undefined' ||
            CQ.WCM.isPreviewMode());
    }

}();

export default UrlService;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/urlService.js
// module id = 30
// module chunks = 0